import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-navy-light py-16 md:py-24 px-4" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.div className="space-y-6 text-lg md:text-xl text-gray-300" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-85">
          <p data-id="element-86">No es que te falte trabajo. No es que no seas bueno.</p>
          <p data-id="element-87">El problema es otro.</p>

          <div className="bg-navy-dark p-6 rounded-lg border border-red-500/20 my-8" data-id="element-88">
            <p className="font-bold text-white text-2xl mb-4" data-id="element-89">
              👉 No tenés un sistema.
            </p>
            <p className="mb-4" data-id="element-90">Y sin sistema…</p>
            <ul className="space-y-3 font-medium text-red-400" data-id="element-91">
              <li className="flex items-center gap-2" data-id="element-92">❌ Perdés clientes</li>
              <li className="flex items-center gap-2" data-id="element-93">❌ Perdés tiempo</li>
              <li className="flex items-center gap-2" data-id="element-94">❌ Perdés dinero</li>
            </ul>
          </div>

          <p data-id="element-95">Y lo peor…</p>
          <p data-id="element-96">Ni siquiera te das cuenta de cuánto.</p>

          <div className="mt-16" data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 border-b border-gold/30 pb-4" data-id="element-98">
              La verdad incómoda que nadie te dice
            </h2>
            <p className="mb-6" data-id="element-99">
              La mayoría de los abogados no falla por falta de conocimiento.
            </p>
            <p className="font-bold text-white text-2xl mb-6" data-id="element-100">
              Falla por desorganización.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-101">
              <li className="flex items-start gap-3" data-id="element-102">
                <span className="text-red-500 mt-1" data-id="element-103">⚠️</span>
                <span data-id="element-104">Casos sin seguimiento</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-105">
                <span className="text-red-500 mt-1" data-id="element-106">⚠️</span>
                <span data-id="element-107">Clientes sin respuesta</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-108">
                <span className="text-red-500 mt-1" data-id="element-109">⚠️</span>
                <span data-id="element-110">Información perdida entre WhatsApp, mails y papeles</span>
              </li>
            </ul>

            <p className="mb-4" data-id="element-111">Todo eso se acumula…</p>
            <p className="mb-8" data-id="element-112">Y te está frenando.</p>
            <p className="mb-4" data-id="element-113">Mientras vos trabajás todo el día…</p>
            <p className="font-bold text-white text-xl" data-id="element-114">Tu estudio no crece.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}